import {
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Portal,
} from '@chakra-ui/react';
import * as React from 'react';

import { Semibold } from '@/imports/ui/chakra/components/Semibold';
import { ChevronDownIcon } from '@/imports/ui/chakra/feather';

import { usePostableGroups } from './hooks/usePostableGroups';

export const GroupMenu = React.forwardRef<
  HTMLButtonElement,
  {
    value: string | undefined;
    onChange: (value: string) => void;
    onBlur: () => void;
    isDisabled?: boolean;
  }
>((props, ref) => {
  const { loading, groups } = usePostableGroups();

  React.useEffect(() => {
    if (!loading && !props.value && groups?.length) {
      props.onChange && props.onChange(groups[0]._id);
    }
  }, [loading, groups, props]);

  const selectedGroupName = groups?.find(
    (group) => group._id === props.value
  )?.name;

  return (
    <Menu placement="top-start" matchWidth>
      <MenuButton
        as={Button}
        isDisabled={loading || props.isDisabled}
        textAlign="left"
        w="full"
        variant="outline"
        colorScheme="gray"
        rightIcon={<ChevronDownIcon />}
        fontWeight="normal"
        onBlur={props.onBlur}
        ref={ref}
      >
        {selectedGroupName ? (
          <>
            Posting in <Semibold>{selectedGroupName}</Semibold>{' '}
          </>
        ) : (
          'Select Group'
        )}
      </MenuButton>

      <Portal>
        <MenuList
          maxHeight={56}
          overflow="auto"
          /**
           * Required to be rendered above chakra modals since this
           * MenuList is portaled to the root of the document body
           */
          zIndex="popover"
        >
          <MenuOptionGroup
            type="radio"
            onChange={props.onChange}
            value={props.value}
          >
            {groups?.map((group) => (
              <MenuItemOption value={group._id} key={group._id}>
                {group.name}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Portal>
    </Menu>
  );
});

GroupMenu.displayName = 'GroupMenu';
